import React from "react";
import "./home.css";
import resume from "../Images/Sachin_Kesarwani_Resume.pdf";
import { Box, Center, Container } from "@chakra-ui/react";
import { Heading, Image } from "@chakra-ui/react";
import { BiArrowToBottom } from "react-icons/bi";
import { redirect } from "../utils";
const Home = () => {
  return (
    <div id="home">
      <div id="homediv">
        <div>
          <Image src="https://img.freepik.com/free-photo/close-up-image-programer-working-his-desk-office_1098-18707.jpg?size=626&ext=jpg&ga=GA1.2.1470629828.1674311466&semt=sph" />
        </div>
        <div style={{ marginTop: "7vw" }}>
          <Heading color={"white"}>Hello , I am </Heading>
          <Heading color={"green"}>SACHIN KESARWANI</Heading>
          <a href={resume} id="resume-link-1" download="Sachin-Kesarwani.pdf">
            <Box
              display={"flex"}
              color={"#2e9b56"}
              id="homeresume"
              boxShadow="0 0 3px 3px rgba(0, 255, 0, 0.5)"
              _hover={{ bg: "#2e9b56", color: "red.400" }}
              width="120px"
              margin="auto"
              marginTop="15px"
              marginBottom="15px"
              padding={"7px"}
              borderRadius="5px"
              border="2px solid  #2e9b56"
              onClick={redirect}
            >
              {" "}
              My resume{" "}
              <BiArrowToBottom fontSize={"20px"} color={"green.600"} />
            </Box>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
